export { default as NotFound } from './routes'; // eslint-disable-line import/prefer-default-export



/** WEBPACK FOOTER **
 ** ./src/app/modules/404/index.js
 **/